import Vue from 'vue'
import axios from 'axios'
import router from '../../../router'
import { ToastProgrammatic as Toast } from 'buefy'

var qs = require('qs')
var jwtDecode = require('jwt-decode')

const state = {
  token: '',
  isAuthenticated: false,
  status: '',
  orgaId: '',
  username: '',
  rights: []
}

const getters = {
  isAuthenticated: state => state.isAuthenticated,
  token: state => state.token,
  authStatus: state => state.status,
  orgaId: state => state.orgaId,
  username: state => state.username,
  rights: state => state.rights
}

const mutations = {
  isProcessingAuthentication: (state) => {
    state.status = 'loading'
  },
  setLoginSuccess: (state, token) => {
    setLoginSuccessValues(state, token)
  },
  setLoginError: (state, error) => {
    console.error('Error during authentication : ' + error)
    state.status = 'error'
    removeCredentials(state)
    Toast.open({ message: 'Invalid credentials', type: 'is-danger' })
  },
  setLogout: (state) => {
    removeCredentials(state)
  },
  setAuthenticationExpired: (state) => {
    state.status = 'error'
    removeCredentials(state)
    Toast.open({ message: 'Error, authentication has expired. You need to reconnect.', type: 'is-danger' })
    router.push('/login')
  },
  set401Error: (state) => {
    state.status = 'error'
    removeCredentials(state)
    Toast.open({ message: 'Error, unauthorized.', type: 'is-danger' })
    router.push('/login')
  },
  set403Error: (state) => {
    state.status = 'error'
    removeCredentials(state)
    Toast.open({ message: 'Access Denied, you are not allowed to access to Acuity Users Management.', type: 'is-danger' })
  },
  setIsAuthenticated: (state, isAuthenticated) => {
    state.isAuthenticated = isAuthenticated
  }
}

const actions = {
  login: ({ commit }, user) => {
    // we must trying to clean the cookie in each login attempt
    Vue.$cookies.remove('KC-TOKEN', '/', '.acuity-cloud.com')

    const requestBody = {
      grant_type: 'password',
      username: user.username,
      password: user.password,
      scope: 'full',
      client_id: 'acuity-route'
    }
    const config = {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      withCredentials: true
    }

    const url = 'https://sso.acuity-cloud.com/auth/realms/' + user.organization + '/protocol/openid-connect/token'
    commit('isProcessingAuthentication')

    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(requestBody), config)
        .then(reponse => {
          commit('setLoginSuccess', reponse.data.access_token)
          resolve(reponse)
        })
        .catch(error => {
          commit('setLoginError', error)
          reject(error)
        })
    })
  },
  logout: ({ dispatch, commit }) => {
    return new Promise((resolve) => {
      dispatch('planning/resetState', null, { root: true })
      commit('setLogout')
      delete axios.defaults.headers.common.Authorization
      resolve()
    })
  }
}

function setLoginSuccessValues (state, token) {
  const decodedToken = jwtDecode(token)
  state.status = 'success'
  state.isAuthenticated = true
  state.token = token
  state.orgaId = decodedToken.organisation
  state.username = decodedToken.username
  state.rights = decodedToken.realm_access.roles
  // Filter and clean roles
  var filteredRights = []
  var techRoles = ['offline_access', 'uma_authorization', 'manage-users', 'view-events']
  for (var right of state.rights) {
    var r = right.replace(new RegExp('^ROLE_'), '')
    if (!filteredRights.includes(r) && !techRoles.includes(r)) {
      filteredRights.push(r)
    }
  }
  filteredRights.sort()
  state.rights = filteredRights

  localStorage.setItem('ORGA_ID', decodedToken.organisation)
  localStorage.setItem('USERNAME', decodedToken.username)
  Vue.$cookies.set('KC-TOKEN', token, null, decodedToken.exp * 1000, '.acuity-cloud.com', process.env.VUE_IS_SECURE_HTTPS, 'Lax')
}

function removeCredentials (state) {
  state.token = ''
  state.isAuthenticated = false
  state.rights = ''
  localStorage.removeItem('ROLES')
  Vue.$cookies.remove('KC-TOKEN', null, '.acuity-cloud.com')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
